// extracted by mini-css-extract-plugin
export var carrierTab = "_5u-0";
export var carrierTabActive = "_5u-1 _5u-0";
export var carrierTabInactive = "_5u-2 _5u-0";
export var carrierTabLabel = "_5u-3";
export var carrierTabLabelActive = "_5u-4 _5u-3";
export var carrierTabLabelInactive = "_5u-5 _5u-3";
export var carrierTabPercentage = "_5u-6";
export var carrierTabPercentageActive = "_5u-7 _5u-6";
export var carrierTabPercentageInactive = "_5u-8 _5u-6";
export var carrierTabWinnable = "_5u-9";
export var carrierTabWinnableActive = "_5u-a _5u-9";
export var carrierTabWinnableInactive = "_5u-b _5u-9";
export var comparisonContainer = "_5u-d";
export var missingRateButton = "_5u-n";
export var missingRateButtonActive = "_5u-o _5u-n";
export var missingRateButtonInactive = "_5u-p _5u-n";
export var missingRateButtonLabel = "_5u-q";
export var missingRateButtonLabelActive = "_5u-r _5u-q";
export var missingRateButtonLabelInactive = "_5u-s _5u-q";
export var sidebar = "_5u-c";
export var strategyButton = "_5u-e";
export var strategyButtonActive = "_5u-f _5u-e";
export var strategyButtonDescription = "_5u-k";
export var strategyButtonDescriptionActive = "_5u-l _5u-k";
export var strategyButtonDescriptionInactive = "_5u-m _5u-k";
export var strategyButtonInactive = "_5u-g _5u-e";
export var strategyButtonLabel = "_5u-h";
export var strategyButtonLabelActive = "_5u-i _5u-h";
export var strategyButtonLabelInactive = "_5u-j _5u-h";
export var unitToggleButton = "_5u-t";
export var unitToggleButtonActive = "_5u-u _5u-t";
export var unitToggleButtonInactive = "_5u-v _5u-t";
export var unitToggleButtonLabel = "_5u-w";
export var unitToggleButtonLabelActive = "_5u-x _5u-w";
export var unitToggleButtonLabelInactive = "_5u-y _5u-w";